import { LogoIconV2 } from "@/assets/images";

const Logo = ({ wrapperClassName = "" }) => {
  return (
    <div className={wrapperClassName}>
      <LogoIconV2 />
    </div>
  );
};

export default Logo;
